import PropTypes from 'prop-types';

export const tabPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  content: PropTypes.array,
});
